import React from 'react';
import { Typography, useTheme } from "@mui/material";
import { AlarmOn } from '@mui/icons-material';
import LoadingDots from "../../../Library/LoadingDots";
import Stopwatch from "../../../Stopwatch";
import type { PartRendererProps } from './types';

const WaitingPart: React.FC<PartRendererProps> = ({ part }) => {
    const theme = useTheme();
    if (part.waitingDetails?.addTimer) {
        return (
            <div style={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap', gap: 2, alignItems: 'flex-start', fontStyle: 'italic', fontSize: '0.8rem', color: 'text.secondary' }}>
                <Typography>{part.waitingDetails.status}: </Typography>
                <Stopwatch
                    id={part.id + "-" + part.waitingDetails?.status.replaceAll(" ", "")}
                    on={part.waitingDetails.stopPoint == undefined}
                    startingPoint={part.waitingDetails.startingPoint}
                    stopPoint={part.waitingDetails.stopPoint!}
                    style={{ marginTop: '2px', marginRight: '4px' }}
                />
                {!part.waitingDetails.isTimerRunning && <AlarmOn sx={{ fontSize: '1.2rem', color: 'secondary.light', top: '4px' }} />}
                {part.waitingDetails.loadDots && <LoadingDots color={theme.palette.text.primary} />}
            </div>
        );
    }
    return <LoadingDots color={theme.palette.text.primary} />;
};

export default WaitingPart;
